<template>
  <div class="chapter-view pt-12 pb-20">
    <div class="col-12 typography--body-1 typography--font-weight-500">
      {{ $t('series_cards.chapters.index', { i: chapter.position }) }}: {{ chapter.name }}

      <small class="link-btns clickable ml-1" v-on:click="$emit('open-chapter-edit-modal', chapter)">{{ $t('common.edit') }}</small>

      <router-link class="link-btns typography--color-primary ml-2" :to="createDocxQuizzesLink">
        <small>
          {{ $t('publishers.create_docx_quizzes.title') }}
        </small>
      </router-link>
    </div>

    <div class="col-12 typography--body-2 typography--color-secondary mt-6">
      <span class="mr-6">
        {{ $t('series_cards.chapters.meta.card_count', { cnt: cardCount }) }}
      </span>
      |
      <span class="ml-6 mr-6">
        {{ $t('series_cards.chapters.meta.domain') }}:
        {{ getDomainLabel(chapter.domain) || '-' }}
      </span>
      |
      <span class="ml-6">
        {{ $t('series_cards.chapters.meta.core_concept') }}:
        {{ getCoreConceptLabel(chapter.core_concept) || '-' }}
      </span>
    </div>

    <div class="col-12">
      <draggable class="chapter-view__card-list row"
                 v-model="chapterCardList"
                 @start="drag=true"
                 @end="drag=false">
        <div class="col-sm-6 col-md-4 col-lg-3" v-for="card in chapterCardList" v-bind:key="card.id">
          <div class="card-row">
            <PublisherCardView
              v-bind:card="card"
              v-bind:is-series-card="true"
              v-on:open-remove-from-series-modal="$emit('open-remove-from-series-modal', card.id)"
              v-on:open-remove-card-modal="$emit('open-remove-card-modal', card.id)"
            />
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { cloneDeep } from 'lodash';
  import draggable from 'vuedraggable';
  import labels from '@/mixins/labels';
  import PublisherCardView from './PublisherCardView';

  export default {
    name: 'chapter-view',

    components: {
      PublisherCardView,
      draggable,
    },

    props: {
      chapter: {
        type: Object,
        default: null,
      },
      seriesItem: {
        type: Object,
        default: null,
      },
    },

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters([
        'cardsByChapterId',
        'chapterCards',
      ]),

      createDocxQuizzesLink() {
        return {
          name: 'publishers.series.chapters.createDocxQuizzes',
          params: {
            series_id: this.seriesItem.id,
            chapter_id: this.chapter.id,
          },
          query: {
            subject_id: this.seriesItem.subject_id,
            grade_id: this.seriesItem.grade_id,
            chapter_name: this.chapter.name,
            chapter_position: this.chapter.position,
            unit_id: this.chapter.unit_id,
          },
        };
      },

      chapterCardList: {
        get() {
          return this.cardsByChapterId[this.chapter.id];
        },

        set(value) {
          const newList = cloneDeep(value);

          /* eslint-disable no-param-reassign */
          newList.forEach((item, i) => {
            item.position = i + 1;
          });
          /* eslint-enable */

          this.storeComponentListClone = newList;

          const modifiedItems = newList.filter(item => (
            item.position !== this.chapterCards[item.id].position
          ));

          Promise.all(modifiedItems.map(item => (
            this.updateSeriesCard({
              series_id: this.seriesItem.id,
              card_id: item.id,
              position: item.position,
            })
          )));
        },
      },

      cardCount() {
        if (this.cardsByChapterId[this.chapter.id]) {
          return this.cardsByChapterId[this.chapter.id].length;
        }

        return 0;
      },
    },

    methods: {
      ...mapActions([
        'updateSeriesCard',
      ]),
    },
  };
</script>

<style lang="scss">
  .chapter-view {
    border-top: 1px solid #d9d9d9;
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/ChapterView.vue